/**
 * Agent Module
 */
const getDefaultState = () => {
  return {
    lineModuleChannelId: '',
    reserveStoreInfoId: ''
  }
}

const state = getDefaultState()

const getters = {
  lineModuleChannelId: (state) => {
    return state.lineModuleChannelId
  },
  lineReserveStoreInfoId: (state) => {
    return state.reserveStoreInfoId
  }
}

const mutations = {
  setLineModuleChannelId (state, data) {
    state.lineModuleChannelId = data
  },
  setLineReserveStoreInfoId (state, data) {
    state.reserveStoreInfoId = data
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reservation/index.js